import { InferOutput, maxLength, pipe, string } from 'valibot'

export const BioSchema = pipe(string(), maxLength(255))

export type Bio = InferOutput<typeof BioSchema>
